export default "__VITE_ASSET__BLMC3zzu__"